import axios from "./axios";
import { WebRotateResponseTypes, ResponseTypes } from "../types/response";
import { GET_WEBROTATE_API } from "../commons/constants/apis";

export const getWebRotate = async (
  code: string,
  language: string
): Promise<any> => {
  try {
    const resp: ResponseTypes<WebRotateResponseTypes> = await axios.get(
      `${GET_WEBROTATE_API}/${code}`,
      { headers: { language } }
    );

    return resp.data;
  } catch (e) {
    return { notFound: true, invalid: undefined };
  }
};
